import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3596 7.34326C11.7282 7.69352 11.7282 8.30648 11.3596 8.65673L5.91565 14.2609C5.5754 14.6403 4.97997 14.6403 4.63973 14.2609C4.27113 13.9106 4.27113 13.2977 4.63973 12.9474L9.43151 7.9854L4.63973 3.0526C4.27113 2.70234 4.27113 2.08939 4.63973 1.73913C4.97997 1.35968 5.5754 1.35968 5.91565 1.73913L11.3596 7.34326Z",
		fill: "currentColor"
	})
});
export default SvgChevron;
